import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

import {
  INITIAL_SERVICE_STATUS,
  LOADED_SERVICE_STATUS,
  companiesNotFoundMsg
} from '../../constants/general';
import { getCompaniesThunk } from '../../store/thunks/companiesThunk';
import { getCompaniesList, getCompaniesStatus } from '../../store/selectors';
import BankTable from './BankTable';
import CompanyDataItem from './CompanyDataItem';
import CompanySelector from './CompanySelector';
import CompanyButtons from './CompanyButtons';

function Companies() {
  const dispatch = useDispatch();
  const companiesList = useSelector(getCompaniesList);
  const companiesLoadStatus = useSelector(getCompaniesStatus);

  if (companiesLoadStatus === INITIAL_SERVICE_STATUS) {
    dispatch(getCompaniesThunk());
  }

  if (companiesLoadStatus !== LOADED_SERVICE_STATUS) {
    return (
      <div className="loader">
        <Spinner animation="border" />
      </div>
    );
  }

  if (companiesList.length > 0) {
    return (
      <Container>
        <Row>
          <Col xs={12} sm={4} className="mb-4">
            <CompanySelector title="company_name" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="edrpou_inn" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="director_fio" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="annual_income" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="annual_limit" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="remaining_income" />
          </Col>
        </Row>
        <Row>
          <Col>
            <BankTable />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="vat_liabilities" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="vat_credit" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="vat_to_pay" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="gross_income" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="gross_expense" />
          </Col>
          <Col xs={6} sm={4} className="mb-4">
            <CompanyDataItem title="profit" />
          </Col>
        </Row>
        <CompanyButtons />
      </Container>
    );
  }

  return (
    <Container>
      <Row className="mt-5">
        <Col className="my-5 text-center">
          <h2>{companiesNotFoundMsg}</h2>
        </Col>
      </Row>
    </Container>
  );
}

export default Companies;
